/**
 * These are the possible keys to use localStorage.
 */
export enum LocalStorageKeys {
  ActivateMatomoLogs = 'ActivateMatomoLogs',
}
